module.exports = __webpack_public_path__ + "img/image10.23bff717.png";